import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpExportAsset } from '../../../api/models/admin';
import { useAppDispatch, useUser } from '../../../app/hooks';
import { addPollingConfiguration, PollingConfiguration } from '../../../data/pollingSlice';
import { addNewTaskExecution } from '../../../data/taskExecutionSlice';
import { promptConfirmationBox, TpConfirmData } from '../../../components/message-boxes/ConfirmBox';
import { taskExecutionPollingId } from '../../../data/pollingService';
import { useNavigate } from 'react-router-dom';
import styles from '../AssetView.module.scss';
import { TaskExecutionType } from '../../../api/models/tasks';
import { FORM_DATATYPES, promptAutoForm, TpAutoFormDef } from '../../../components/auto-form-modal/AutoForm';
import { useM2MApiContext } from '../../../api/m2mApi';

interface TpExportAssetButtonProps {
  assetId: string;
}

const ExportAssetButton = ({ assetId }: TpExportAssetButtonProps) => {
  const dispatch = useAppDispatch();
  const { user } = useUser();
  const adminApi = useM2MApiContext().organizationAdmin;
  const navigate = useNavigate();

  const organizationId = user.organizations.find((org) => org.isActive)?.organizationId;

  const promptExportAsset = (organizationName: string): Promise<TaskExecutionType> => {
    const form: TpAutoFormDef = {
      title: `Export Asset`,
      fields: [
        {
          id: 'relatedAssets',
          name: 'Include related assets in export',
          dataType: FORM_DATATYPES.CHECKBOX,
          startContent: false,
          required: false,
        },
      ],
    };

    return promptAutoForm(form).then((dataForm: any) => {
      const exportAssetData: TpExportAsset = {
        organizationName: organizationName,
        assetId: assetId,
        userEmail: user.email!,
        relatedAssets: dataForm.relatedAssets,
      };

      return adminApi.exportAsset(exportAssetData).then((resp) => {
        return resp;
      });
    });
  };

  const handleExportAction = () => {
    if (!organizationId) {
      return;
    }
    adminApi
      .fetchOrganization(organizationId)
      .then((organization) => promptExportAsset(organization.name))
      .then((taskExecution) => {
        const confirmData: TpConfirmData = {
          title: `Your Data Export has just started`,
          description: `Would you like to proceed to the 'Task Executions' page? \n\n`,
          cancelButtonLabel: `Close`,
        };
        if (taskExecution) {
          const pollingConfig: PollingConfiguration = {
            identifier: taskExecutionPollingId,
            interval: 15000,
          };
          dispatch(addNewTaskExecution({ taskExecution }));
          dispatch(addPollingConfiguration(pollingConfig));
        }

        return promptConfirmationBox(confirmData).then((confirmed) => {
          if (confirmed) {
            navigate(`/task-executions`);
          }
        });
      });
  };

  return (
    <FontAwesomeIcon
      className={styles.exportIcon}
      icon={['fas', 'file-export']}
      onClick={handleExportAction}
      title="Export Data"
    />
  );
};

export default ExportAssetButton;
